import {
  LOGIN_BEGIN,
  LOGIN_FAILURE,
  LOGIN_SUCCESS,
  AUTO_LOGIN,
} from "../actions/loginactions";

const initialState = {
  loading: false,
};

export function loginReducer(state = initialState, action) {
  const nextState = Object.assign({}, state);

  switch (action.type) {
    case AUTO_LOGIN:
      return nextState;
    case LOGIN_BEGIN:
      nextState.loading = true;
      return nextState;
    case LOGIN_SUCCESS:
      nextState.loading = false;
      return nextState;
    case LOGIN_FAILURE:
      nextState.loading = false;
      return nextState;
    default:
      return state;
  }
}
